
import PictureComp from '@/components/picture/PictureComp.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import TitleDetailLink from '@/components/nav/links/TitleDetailLink.vue';

import { ModuleContentTitleTrend } from '@/@types/graphql-types';
import { ThumborOptions } from '@/filters/thumbor';

@Component({
	name: 'TitleDetailStreamingChartListItem',
	components: { PictureComp, TitleDetailLink },
})
export default class TitleDetailStreamingChartListItem extends Vue {
	@Prop({ required: true }) titleName: string;
	@Prop({ required: true }) posterUrl: string;
	@Prop({ required: true }) chartPosition: number;
	@Prop({ required: true }) titleUrl: string;
	@Prop({ default: '' }) chartPositionDynamic: ModuleContentTitleTrend;
	@Prop() daysInTop1000: number;
	@Prop() chartMovement: number;
	@Prop({ default: null }) showSeason: number;
	@Prop() isTitle: string;
	@Prop() title: any;

	get imgSrc() {
		return Vue.filter('Thumbor')({
			url: this.posterUrl,
			imageType: 'poster',
		} as ThumborOptions);
	}

	get formattedChartPosition() {
		return this.chartPosition.toLocaleString('en-US', {
			minimumIntegerDigits: 2,
			useGrouping: false,
		});
	}

	get arrowClasses() {
		if (!this.showArrow) {
			return null;
		}

		return {
			'streaming-chart-list-item__arrow': !!this.chartPositionDynamic,
			'streaming-chart-list-item__arrow--up': this.chartPositionDynamic === ModuleContentTitleTrend.Up,
			'streaming-chart-list-item__arrow--stable': this.chartPositionDynamic === ModuleContentTitleTrend.Stable,
			'streaming-chart-list-item__arrow--down': this.chartPositionDynamic === ModuleContentTitleTrend.Down,
		};
	}

	get showArrow() {
		return this.chartPositionDynamic && !this.isNew;
	}

	get isNew() {
		return (
			(this.daysInTop1000 === 0 && this.chartPosition <= 1000) ||
			this.chartPositionDynamic === ModuleContentTitleTrend.New ||
			this.chartMovement >= 5000
		);
	}

	get seasonNumber() {
		return `${this.$t('WEBAPP_SEASON')} ${this.showSeason}`;
	}

	get trendDifference() {
		if (this.chartPositionDynamic === ModuleContentTitleTrend.Up) return `+${this.chartMovement}`;
		if (this.chartPositionDynamic === ModuleContentTitleTrend.Stable) return '—';
		if (this.chartPositionDynamic === ModuleContentTitleTrend.Down) return `${this.chartMovement}`;
	}
}
